import ReusableDataTable from "src/components/table/ReusableDataTable";
import { mapWardToDataTable as mapData } from "./Helper";
import GetWardColumns from "./ColumnDefinition/WardColumn/GetWardColumns";

const WardTable = ({
  data,
  handleDelete,
  handleOpenPopup,
  status,
  districtId,
}) => {
  const columns = GetWardColumns({
    handleDelete,
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable
      columns={columns}
      data={mapData(data, districtId)}
      maxHeight={450}
    />
  );
};

export default WardTable;
